import React from "react";

// Components
import Button from "components/Button";

// Libs
import { toast } from "react-toastify";

// Services
import DashboardService from "services/dashboard";

// Context
import { useGeneralProvider } from "contexts/general";

// Imgs
import CloseIconSvg from "assets/close-icon.svg";

import {
  BackDrop,
  Container,
  ImageWrapper,
  CloseIcon,
  Header,
  HeaderText,
  FooterContainer,
} from "./styles";

function ModalConfirmUpdate({ setShowModal, companyId, handleCleanFilters }) {
  const { setLoading, globalUser } = useGeneralProvider();
  const userPassService = new DashboardService(globalUser);

  const handleUpdateCompany = () => {
    setLoading(true);

    userPassService
      .updateCompanyStatus({
        companyId: companyId,
        companyStatus: 1,
      })
      .then(() => {
        toast.success("Cliente inativado com sucesso!");
        handleCleanFilters();
        setShowModal(false);
      })
      .catch((err) => {
        setLoading(false);

        if (err?.response?.data?.message) {
          toast.error(err.response.data.message);
        } else {
          toast.error("Falha ao inativar cliente");
        }
      });
  };

  return (
    <BackDrop>
      <Container>
        <Header>
          <ImageWrapper />
          <HeaderText>Deseja inativar este cliente?</HeaderText>
          <ImageWrapper onClick={() => setShowModal(false)}>
            <CloseIcon src={CloseIconSvg} />
          </ImageWrapper>
        </Header>
        <FooterContainer>
          <Button label="Confirmar" onClick={() => handleUpdateCompany()} />
        </FooterContainer>
      </Container>
    </BackDrop>
  );
}

export default ModalConfirmUpdate;
